import { Provider } from './provider';

export class ProviderFlixmedia extends Provider {
    public getAvailabilitySource(): string {
        return `https://syndication.flix360.com/delivery/webcall/match/877/de/ean/${this.ean}`;
    }

    public isContentAvailable(parsedAvailabilityResponse: Record<string, string>): boolean {
        return parsedAvailabilityResponse.event === 'matchhit';
    }

    public createIframeSrc(): string {
        return `https://syndication.flix360.com/delivery/webcall/content/877/de/ean/${this.ean}`;
    }
}
